import React, { useState } from "react";
import { login } from "../api";

function LoginPage({ onLoggedIn, onGoToSignup, onForgotPassword }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      onLoggedIn();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark-scope relative min-h-screen flex items-center justify-center px-4 py-10 overflow-hidden" style={{ background: "var(--ink)" }}>
      {/* Ambient background ornaments */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[rgba(201,162,39,0.07)] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 -left-24 w-96 h-96 rounded-full bg-[rgba(62,134,134,0.10)] blur-3xl" />

      <div className="relative z-10 w-full max-w-sm animate-rise">
        {/* Logo lockup */}
        <div className="text-center mb-7">
          <div className="inline-flex flex-col items-center">
            <span className="text-6xl font-arabic-display text-dt-gold-bright leading-none mb-2" dir="rtl">
              مراجعة
            </span>
            <div className="rule-ornament w-40 text-sm">
              <span className="text-gold-400">✦</span>
            </div>
            <p className="mt-2 text-xs uppercase tracking-[0.25em] text-dt-gold-dim font-medium">
              murājaʿa
            </p>
          </div>
        </div>

        <div className="surface-glass rounded-2xl shadow-soft-lg p-8">
          <h2 className="text-2xl font-display font-semibold text-ink-800 mb-1">Welcome back</h2>
          <p className="text-sm text-ink-400 mb-6">Continue your study where you left off.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-ink-500 mb-1.5">
                Email address
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full px-3.5 py-2.5 rounded-xl border border-parchment-300 bg-white/80 text-base text-ink-800 placeholder:text-ink-300 focus:outline-none focus:ring-2 focus:ring-[var(--gold)] focus:border-[var(--gold)] transition"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-ink-500 mb-1.5">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Your password"
                className="w-full px-3.5 py-2.5 rounded-xl border border-parchment-300 bg-white/80 text-base text-ink-800 placeholder:text-ink-300 focus:outline-none focus:ring-2 focus:ring-[var(--gold)] focus:border-[var(--gold)] transition"
              />
            </div>

            {error && (
              <p className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-xl bg-dt-gold-bright text-dt-ink font-semibold text-sm hover:brightness-105 disabled:opacity-50 shadow-soft transition-colors"
            >
              {loading ? "Logging in…" : "Log in"}
            </button>

            <div className="text-center">
              <button
                type="button"
                onClick={onForgotPassword}
                className="text-sm text-ink-500 hover:text-ink-700 underline-offset-2 hover:underline"
              >
                Forgot your password?
              </button>
            </div>
          </form>

          <p className="mt-6 text-sm text-ink-400 text-center">
            Don't have an account?{" "}
            <button
              onClick={onGoToSignup}
              className="text-ink-600 hover:text-ink-700 font-semibold underline-offset-2 hover:underline"
            >
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
